import { Component, Input, OnInit } from "@angular/core"
import { UserService } from "../../../../services/user.service"
import { ModalRef } from "../../../modal/modal-ref"
import { ModalService } from "../../../modal/modal.service"
import { StudentLoginModalComponent } from "../../student-login-modal/student-login-modal.component"
import { AuthModalComponent } from "../auth-modal.component"
import { StudentLogin } from "../../../../models/studentLogin"
import { Router } from "@angular/router"
import { StudentSignupModalComponent } from "../../student-signup-modal/student-signup-modal.component"
import { STATIC_IMAGES } from "../../../../models/constants"

@Component({
    selector: "app-auth-modal-content",
    templateUrl: "./auth-modal-content.component.html",
    styleUrls: ["./auth-modal-content.component.scss"],
})
export class AuthModalContentComponent implements OnInit {
    public isStudent = false
    public googleImage
    public facebookImage
    public pbsImage
    public isStudentTab: boolean = false
    public studentUsername: string = null
    public secretAnswer: string = null
    public studentLogin: StudentLogin
    googleAuthUrl: string
    facebookAuthUrl: string
    pbsAuthUrl: string

    @Input() public nextURL: string = null
    @Input() public activeModal: ModalRef = null
    @Input() public title: string = "Welcome back!"
    @Input() public description: string
    @Input() public registerDescription: string = "Need an account?"
    @Input() public registerLinkText: string = "Click here to get started."
    @Input() public pbsEmailRegister: boolean = false

    constructor(
        public userService: UserService,
        private modalService: ModalService,
        private router: Router
    ) {
        this.googleImage = STATIC_IMAGES.auth_google
        this.facebookImage = STATIC_IMAGES.auth_facebook
        this.studentLogin = new StudentLogin(this.userService, this.router)
    }

    public ngOnInit() {
        this.isStudent = this.userService.hasStudentExperience()
        if (!this.description) {
            this.description = "Use one of the services below to sign in to PBS LearningMedia:"
        }
        this.googleAuthUrl = this.userService.getGoogleAuthUrl(this.nextURL, this.isStudent)
        this.facebookAuthUrl = this.userService.getFacebookAuthUrl(this.nextURL)
        this.pbsAuthUrl = this.userService.getPbsAuthUrl(this.nextURL, this.pbsEmailRegister)
    }

    public activateStudentTab() {
        this.description = "Access your assignments, projects, and favorites by signing in."
        this.isStudentTab = true
    }

    public activateTeacherTab() {
        this.description = "Use one of the services below to sign in to PBS LearningMedia:"
        this.isStudentTab = false
    }

    public closeAuthModal() {
        if (this.activeModal) {
            this.activeModal.close()
        }
    }

    public openAuthModal() {
        this.modalService.open(AuthModalComponent, {
            data: {
                nextURL: this.nextURL,
            },
        })
    }

    public openStudentAuthModal() {
        this.modalService.open(StudentLoginModalComponent)
    }

    public getStudentNext() {
        return this.studentLogin.getCurrentStudentPath(this.nextURL)
    }

    public openStudentSignUp() {
        this.closeAuthModal()
        this.modalService.open(StudentSignupModalComponent, { size: "lg" })
    }
}
